import { FileServiceClient } from '@playq/octopus2-files';

import { transport } from '/api/core';

export const filesService = new FileServiceClient(transport);
